import React from "react";
import { Link } from "react-router-dom";
import MarketingNav from "@/components/site/MarketingNav";
import Footer from "@/components/site/Footer";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export default function About() {
  return (
    <div className="min-h-screen bg-background" data-testid="about-page">
      <MarketingNav />
      <section className="border-b border-border">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-12">
          <div className="md:col-span-7 border-r border-border p-8 md:p-16">
            <div className="overline text-muted-foreground">About Draftwave</div>
            <h1 className="font-serif-display text-5xl md:text-7xl leading-none tracking-tight mt-4">
              A studio for
              <br />
              <span className="italic text-primary">people who write</span>
              <br />
              like they mean it.
            </h1>
            <p className="mt-8 max-w-xl text-muted-foreground text-base md:text-lg leading-relaxed">
              Draftwave is an editorial-grade content studio built for solo founders, indie
              creators, and micro-teams who care about voice. We believe great content sounds like
              a person — not a template — and that recurring revenue is the calmest way to run a
              business.
            </p>
            <p className="mt-6 max-w-xl text-muted-foreground text-base md:text-lg leading-relaxed">
              Our tools stitch together the best AI models available (Claude, GPT-4o, Gemini,
              GPT Image) behind one clean, editorial-first interface. You get six
              domain-specialized generators, an image lab, an SEO pack, a referral engine, and a
              live journal — for less than a decent lunch.
            </p>
            <div className="mt-10 flex gap-3">
              <Link to="/pricing">
                <Button className="rounded-none h-12 px-6 font-mono uppercase tracking-widest text-xs">
                  See pricing <ArrowRight className="w-4 h-4 ml-1" />
                </Button>
              </Link>
              <Link to="/contact">
                <Button variant="outline" className="rounded-none h-12 px-6 font-mono uppercase tracking-widest text-xs">
                  Say hello
                </Button>
              </Link>
            </div>
          </div>
          <div className="md:col-span-5">
            <div className="p-8 md:p-12 border-b border-border">
              <div className="overline text-muted-foreground">Manifesto</div>
              <blockquote className="mt-4 font-serif-display text-2xl md:text-3xl leading-tight">
                "Write like you're building a canon, not a content mill."
              </blockquote>
              <p className="mt-4 text-sm text-muted-foreground">— The Draftwave editorial standard</p>
            </div>
            <div className="p-8 md:p-12">
              <div className="overline text-muted-foreground">Where we are</div>
              <div className="mt-4 font-mono text-sm">
                Draftwave Editorial Co.
                <br />
                11642 Victory Blvd, Unit 2032
                <br />
                North Hollywood, CA 91606
                <br />
                <a href="mailto:info@draftwave.online" className="text-primary hover:underline">
                  info@draftwave.online
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
